import React from 'react';
import { cc } from '../../modules/styles';

import './BarButton.css';

/**
 * Button for the bottom bar
 */

function BarButton({
  children,
  className,
  onClick,
  tooltip,
  href,
  'aria-haspopup': ariaHasPopup,
  'aria-expanded': ariaExpanded,
}) {
  const Element = href ? 'a' : 'button';
  return (
    <Element
      className={cc('BarButton reset-button', className)}
      onClick={onClick}
      title={tooltip}
      href={href ? href : null}
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
    >
      {children}
    </Element>
  );
}

export default BarButton;
